// Public pages of an organization created by sign-up are opened with
// ?system=<code> (e.g. /?system=acme-co). The public pages link to each other
// with plain links (/about, /booking, /login ...), which would silently drop
// that code and show the wrong organization. This keeps the code on those links.
const PUBLIC_PATHS = [
    '/', '/about', '/services', '/booking', '/report', '/contact', '/login', '/signup',
    '/forgot-password', '/privacy-policy', '/terms-of-service',
];

try {
    const slug = new URLSearchParams(window.location.search).get('system');
    if (slug) {
        document.addEventListener('click', event => {
            const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
            if (!link) return;
            const url = new URL(link.href, window.location.href);
            if (url.origin !== window.location.origin) return;
            if (!PUBLIC_PATHS.includes(url.pathname) || url.searchParams.has('system')) return;
            url.searchParams.set('system', slug);
            link.setAttribute('href', url.pathname + url.search + url.hash);
        }, true);
    }
} catch (error) { /* never break the page over this */ }
